import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { officialLicenseTypeService } from "../../_services/officialLicenseType.service";
import StandardAutoComplete from "./standard.autocomplete";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
}

export const OfficialLicenseTypeAutoComplete = (params: IStandardExtAutocomplete) => {

    return (
        <StandardAutoComplete
            {...params}
            itemsLoader={officialLicenseTypeService.dropdown}
            label={"Official Licence Type Select"} />
    );
}